import { useTranslation } from '@sm360/hooks'
import { updateDrCalculatorFinish } from '@sm360/helpers'
import { Button, Icon, Modal } from '@sm360/ui-library'
import React from 'react'

import TabsCalculator from '../../components/tabsCalculator/TabsCalculator'
import { Context } from '../../configs/state.manager'
import { WindowProxy } from '../../utils/handle-url.utils'
import { addToGarage, goToCheckout, isQuoteInGarage, updateQuote } from '../../utils/showroom.utils'
import ModalView from '../modal/Modal.view'
import DrawerView from '../drawer/Drawer.view'

// Component to differenciate for Modal or Drawer view
const HOC = ({ isDrawer, children }) => {
    return <>{isDrawer ? <DrawerView>{children}</DrawerView> : <ModalView>{children}</ModalView>}</>
}

const Wrapper = () => {
    const {
        state: {
            isFetching,
            hasShowroomWidgets,
            paymentOptions,
            quoteInfos,
            quotesInGarage,
            quoteId,
            vehicle,
            vehicle: { disclaimerGeneral },
            category,
            isStandaloneVLP,
            dealerInfos: { orgId },
            calculatorView,
        },
    } = React.useContext(Context)

    const { t } = useTranslation()
    const [hasQuoteInGarage, setHasQuoteInGarage] = React.useState(false)

    const [isModalOpen, setModalOpen] = React.useState(false)

    const isHumberview = parseInt(orgId) === 2289
    React.useEffect(() => {
        const fetchData = async () => {
            const isInGarage = isQuoteInGarage(quotesInGarage, quoteId)
            setHasQuoteInGarage(isInGarage)
        }

        fetchData()

        // showroom widget event when removing vehicle from garage
        WindowProxy.document.addEventListener('sm360.widgets.garage.removed', (e) => {
            if (quoteId === e?.detail?.quoteId) {
                setHasQuoteInGarage(false)
            }
        })
        if (!isModalOpen) {
            if (WindowProxy) {
                setModalOpen(true)
                setTimeout(() => WindowProxy.document.dispatchEvent(new Event('sm360.calculator.vlp.modal.open')), 1000)
            }
        }
    }, [quoteId, quotesInGarage])

    if (isFetching) {
        return <div className='skeleton skeleton-cta'></div>
    }

    // Only show button if there's a valid quote ID
    if (!isFetching && !quoteId) {
        return <></>
    }

    const onAddToGarage = (setClose) => {
        onSetClose(setClose)
        addToGarage(vehicle, paymentOptions, category)
    }

    const checkoutUrl = hasQuoteInGarage ? t('pc.checkoutUrl', { quoteId }) : ''

    const onSetClose = (setClose) => {
        document.body.style.overflow = 'auto'
        document.body.style.paddingRight = '0px'
        setClose && setClose()
        if (isModalOpen) {
            if (WindowProxy) {
                setModalOpen(false)
                setTimeout(() => WindowProxy.document.dispatchEvent(new Event('sm360.calculator.vlp.modal.close')), 1000)
            }
        }
        if (!isStandaloneVLP) {
            if (hasQuoteInGarage) {
                updateQuote(quoteInfos, paymentOptions, vehicle)
            }
            WindowProxy.document.dispatchEvent(
                new CustomEvent('sm360.calculator.vdp.modal.close', {
                    detail: {
                        paymentOptions,
                    },
                })
            )
        }

        updateDrCalculatorFinish(quoteId, vehicle, paymentOptions?.purchaseMethod)
    }
    // Default is the Modal view
    const isDrawerView =
        typeof calculatorView === 'string' && calculatorView.length > 0 && calculatorView.toUpperCase() === 'DRAWER'
    return (
        <HOC isDrawer={isDrawerView}>
            {({ setClose }) => (
                <>
                    <Button closeButton onClick={() => onSetClose(setClose)} />

                    <TabsCalculator version={!!isHumberview ? 'alpha' : ''} />

                    <div className='uk-modal__actions pc-modal__actions'>
                        <div className='pc-modal__buttonCta'>
                            {hasShowroomWidgets && !hasQuoteInGarage && (
                                <Button
                                    className='a-button -primary'
                                    label={t('pc.addToGarage')}
                                    onClick={() => onAddToGarage(setClose)}
                                />
                            )}

                            {hasShowroomWidgets && (
                                <Button
                                    className='a-button -secondary'
                                    label={t('pc.buyOnline')}
                                    onClick={() => goToCheckout(vehicle, paymentOptions, checkoutUrl)}
                                />
                            )}
                        </div>
                        <div className='pc-modal__offerDetails'>
                            <Modal
                                modalTitle=''
                                trigger={
                                    <div>
                                        <Icon name='info-circle' className='pc-modal__iconDisclaimer' />

                                        <Button
                                            className='pc-modal__buttonDisclaimer'
                                            color='primary'
                                            label={t('pc.offerDetails')}
                                            displayAsLink
                                        />
                                    </div>
                                }
                                className='pc-modal__inner'
                            >
                                <div className='pc-disclaimer'>{disclaimerGeneral}</div>
                            </Modal>
                        </div>
                    </div>
                </>
            )}
        </HOC>
    )
}

export default Wrapper
